import postApi from "../api/postApi";
import * as url from "../api/url";

// Post Comany and Contact API
export const postComanyAndContact = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.SAVE_COMPANY_AND_CONTACT, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
